'use client';

import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';

const SectionWhat: React.FC<{ data: any }> = ({ data }) => {
  const sectionWhat1Data = data.contentInfo['section-what1'];
  const sectionWhat2Data = data.contentInfo['section-what2'];
  return (
    <section className={styles.sectionWhat}>
      <h2 className={styles.title}>{sectionWhat1Data.title}</h2>
      <div className={styles.cardsContainer}>
        <div className={styles.imgWrapper}>
          <Image
            src={sectionWhat1Data.imgPath}
            alt={sectionWhat1Data.title}
            width={0}
            height={0}
            sizes="100vw"
            className={styles.mainImg}
          />
        </div>
        <h3 className={styles.cardsTitle}>{sectionWhat1Data.desc}</h3>
        <div className={styles.cards}>
          {sectionWhat1Data.cards.map((card: any, index: number) => (
            <div key={card.title} className={styles.card}>
              <div className={styles.titleWrapper}>
                <div
                  className={styles.iconWrapper}
                  style={{
                    backgroundColor: index === 0 ? '#DAE6FA' : index === 1 ? '#CDE0BE' : '#FAEDE0',
                  }}
                >
                  <Image src={card.imgPath} alt={card.title} width={32} height={32} className={styles.cardIcon} />
                </div>
                <h4 className={styles.cardTitle}>{card.title}</h4>
              </div>
              <p className={styles.cardDesc}>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.contentContainer}>
        <h3 className={styles.contentTitle}>{sectionWhat2Data.title}</h3>
        <div className={styles.contentLeft}>
          <Image
            src={sectionWhat2Data.imgPath}
            alt={sectionWhat2Data.title}
            width={0}
            height={0}
            sizes="100vw"
            className={styles.contentImg}
          />
        </div>
        <div className={styles.contentRight}>
          <div className={styles.contentRightTitle}>{sectionWhat2Data.desc}</div>
          {sectionWhat2Data.cards.map((card: any, index: number) => (
            <p key={index} className={styles.contentDesc}>
              {card.desc}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionWhat;
